import { BankServiceApiFactory } from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export const fetchBanks = async () => {
  const client = createLayupClient();
  const response = await BankServiceApiFactory(undefined, undefined, client).bankServiceGetMany();
  return response.data;
};
